import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import { patchJefeRechazo } from "./ApiServices";
import ExpedienteArchivos from "./ExpedienteArchivos";
import { TIPOS_ARCHIVO_RECHAZO } from "./chequesRechazos.constants";

export default function ModalJefeRechazo({ open, onClose, rechazo, onOk }) {
  const [valorRechazado, setValorRechazado] = useState(false);
  const [avisoCc, setAvisoCc] = useState(true);
  const [obs, setObs] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setValorRechazado(false);
    setAvisoCc(true);
    setObs("");
    setError("");
  }, [open, rechazo]);

  const idRechazo = rechazo?.id ?? rechazo?.id_rechazo;

  const guardar = async () => {
    if (!idRechazo) return;
    if (!valorRechazado) {
      setError("Confirmá que el valor quedó marcado como rechazado en la plataforma.");
      return;
    }
    if (!avisoCc) {
      setError("Confirmá el aviso a Cuentas Corrientes.");
      return;
    }
    setGuardando(true);
    setError("");
    try {
      await patchJefeRechazo(idRechazo, {
        valor_rechazado: true,
        aviso_cc: true,
        obs: obs.trim() || undefined,
      });
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al formalizar el rechazo");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Jefe de área — formalizar rechazo</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Alert severity="info">
            El rechazo del valor se registra en esta plataforma (no en Sisven).
            Aportá información al expediente y avisá a Cuentas Corrientes.
          </Alert>
          <FormControlLabel
            control={
              <Checkbox
                checked={valorRechazado}
                onChange={(e) => setValorRechazado(e.target.checked)}
                disabled={guardando}
              />
            }
            label="Marqué el valor como rechazado en la plataforma"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={avisoCc}
                onChange={(e) => setAvisoCc(e.target.checked)}
                disabled={guardando}
              />
            }
            label="Di aviso a Cuentas Corrientes"
          />
          <TextField
            size="small"
            fullWidth
            multiline
            minRows={2}
            label="Información adicional (opcional)"
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
          <ExpedienteArchivos
            idRechazo={idRechazo}
            tipoDefault={TIPOS_ARCHIVO_RECHAZO.OTRO}
            compact
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Avisar a CC
        </Button>
      </DialogActions>
    </Dialog>
  );
}
